import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { BitmapText, Container } from '@pixi/react';
import { useMemo } from 'react';
import { useAppSelector } from '../../../redux/store';
import { getBitmapTextMetricsWithTruncation } from '../../../utils/textMetricsUtils';
import { isTestEnvironment } from '../../../utils/utils';
import { PlayerActionTimerBarContainer } from './playerActionTimerBarContainer';
import { USERNAME_LETTER_SPACING } from './usernameTextStyles';
function getUsernameForegroundStyle(isActiveTimerSeat, isSeatedPlayerSittingOut, isSeatedPlayerIn) {
    if (isActiveTimerSeat) {
        return 'active-timer-foreground-text';
    }
    if (isSeatedPlayerSittingOut || !isSeatedPlayerIn) {
        return 'dimmed-username-foreground-text';
    }
    // still in the hand, but not this player's turn
    return 'inactive-timer-foreground-text';
}
function getUsernameBackgroundStyleAndAlpha(isActiveTimerSeat) {
    if (isActiveTimerSeat) {
        return { bitmapTextStyleType: 'active-timer-background-text', alpha: 0.5 };
    }
    return { bitmapTextStyleType: 'inactive-username-background-text', alpha: 1 };
}
export const UsernameBadgeContents = ({ seatIndex, bounds }) => {
    const isActiveTimerSeat = useAppSelector((state) => !!state.poker.actionTimer?.seatIndexes.includes(seatIndex));
    const isSeatedPlayerSittingOut = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.isSittingOut);
    const isSeatedPlayerIn = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.isIn);
    const seatedPlayerName = useAppSelector((state) => state.poker.seatedPlayers[seatIndex]?.name);
    const { w, h } = bounds;
    const bitmapTextMetrics = useMemo(() => {
        if (!bounds) {
            return;
        }
        if (!seatedPlayerName) {
            return;
        }
        return getBitmapTextMetricsWithTruncation(seatedPlayerName, 'active-timer-foreground-text', bounds.w, {
            letterSpacing: USERNAME_LETTER_SPACING
        });
    }, [bounds, seatedPlayerName]);
    if (!bitmapTextMetrics) {
        return null;
    }
    const { bitmapTextStyleType: usernameBackgroundStyle, alpha: backgroundTextAlpha } = getUsernameBackgroundStyleAndAlpha(isActiveTimerSeat);
    const usernameForegroundStyle = getUsernameForegroundStyle(isActiveTimerSeat, isSeatedPlayerSittingOut, isSeatedPlayerIn);
    const pixiData = isTestEnvironment()
        ? { type: 'player-name-badge-text', seatIndex, username: seatedPlayerName }
        : null;
    const backgroundTextElement = (_jsx(BitmapText
    // Workaround an apparent bug in react-pixi-fiber that doesn't see changes in style.fontName by explicitly setting a unique key value:
    , { text: bitmapTextMetrics.text, style: { fontName: usernameBackgroundStyle, letterSpacing: USERNAME_LETTER_SPACING } }, `${usernameBackgroundStyle}-${bitmapTextMetrics.text}`));
    return (_jsxs(_Fragment, { children: [_jsx(PlayerActionTimerBarContainer, { seatIndex: seatIndex, w: w, h: h }), _jsxs(Container, { x: -Math.round(bitmapTextMetrics.dimensions.w / 2), y: -Math.round(bitmapTextMetrics.dimensions.h / 2), children: [backgroundTextAlpha < 1 ? (_jsx(Container, { alpha: backgroundTextAlpha, children: backgroundTextElement })) : (backgroundTextElement), _jsx(BitmapText
                    // Workaround an apparent bug in react-pixi-fiber that doesn't see changes in style.fontName by explicitly setting a unique key value:
                    , { "pixi-data": pixiData, text: bitmapTextMetrics.text, style: { fontName: usernameForegroundStyle, letterSpacing: USERNAME_LETTER_SPACING } }, `${usernameForegroundStyle}-${bitmapTextMetrics.text}`)] })] }));
};
